// src/components/ErrorBoundary.js
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Actualiza el estado para que el siguiente renderizado muestre la UI de respaldo.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // También puedes registrar el error en un servicio de reporte de errores
    console.error("Error capturado por ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Puedes renderizar cualquier UI de respaldo.
      return (
        <div className="p-6 bg-red-50 border-l-4 border-red-500 text-red-700">
          <h2 className="font-bold">Algo salió mal.</h2>
          <p>Por favor, recarga la página o intenta más tarde.</p>
          {/* Opcional: mostrar detalles del error en desarrollo */}
          {process.env.NODE_ENV === 'development' && (
            <details className="mt-2 text-sm">
              <summary>Detalles del error</summary>
              <pre className="mt-2 whitespace-pre-wrap">
                {this.state.error && this.state.error.toString()}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;